import { ROOT_PATH, LER_NEWSSTAND_ROOT_PATH } from 'routes/paths'
import type { LocationType } from './types'
import type { UserState } from 'utils/hooks/use-userInfo'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  // for SOMOS the Home page is "Banca"
  if (user.isClientSomos && currentPath === ROOT_PATH) {
    return { pathname: LER_NEWSSTAND_ROOT_PATH }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
